<script lang="ts">
    import { TextField, Icon, List, ListItem } from 'svelte-materialify';
    import { Container, Menu, ListItemGroup } from 'svelte-materialify/src';

    let active = false;
    let selection = [];
</script>

<div class="tracing">
    <Container id="autocomplete">
        <Menu bind:active closeOnClick={true} style="width: 100%">
            <span slot="activator">
                <TextField solo placeholder="Who tested positive?" on:change={() => active = true}>
                    <div slot="prepend">
                        <Icon class="material-icons">search</Icon>
                    </div>
                </TextField>
            </span>
            <ListItemGroup bind:value={selection} mandatory={false} multiple={false}>
                <ListItem>Test</ListItem>
                <ListItem>Testers</ListItem>
            </ListItemGroup>
        </Menu>
    </Container>
</div>

<style>
    /*.tracing {*/
    /*    max-width: 1000px;*/
    /*    margin: 0 auto;*/
    /*}*/
</style>